import Rails from "@rails/ujs"

export function syntheticEvent(el, eventName) {
  console.log("[syntheticEvent]", eventName, "on", el)
  const event = new Event(eventName, { bubbles: true })
  el.dispatchEvent(event)
  Rails.handleRemote.call(el, event)
}
